/**
 * @file: index.tsx
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * The 跟进动态 section: the activity timeline with a 跟进记录 affordance in
 * the header for logging a new follow-up while the lead is active.
 */

import { LeadActivityView } from '@euler/model/lead/LeadActivity';
import { Card } from '../common/Card';
import { SectionAction } from '../common/SectionAction';
import { SectionHeader } from '../common/SectionHeader';
import { LeadActivityTimeline } from './LeadActivityTimeline';

export const FollowUpSection = ({
  activities,
  terminal,
  onAddActivity,
}: {
  activities: LeadActivityView[];
  terminal: boolean;
  onAddActivity: () => void;
}) => {
  return (
    <>
      <SectionHeader
        title="跟进动态"
        right={
          !terminal ? (
            <SectionAction label="跟进记录" onPress={onAddActivity} />
          ) : null
        }
      />
      <Card>
        <LeadActivityTimeline activities={activities} />
      </Card>
    </>
  );
};
